<template>
  <v-card tile flat color="grey lighten-4 mb-6" elevation="0">
    <v-row>
      <v-col cols="3">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="d-flex">
              <strong>
                {{ $t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER') }}
              </strong>
            </v-list-item-title>
            <v-list-item-subtitle class="d-flex text-wrap text--primary"
              >{{ customer }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="3">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{ $t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY') }}
              </strong>
            </v-list-item-title>
            <v-list-item-subtitle class="d-flex text-wrap text--primary"
              >{{ managementCompany }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="3">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{ $t('BUILDING_COMPLEXES.CONCIERGE') }}
              </strong>
            </v-list-item-title>
            <v-list-item-subtitle class="d-flex text-wrap text--primary"
              >{{ concierge }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="3">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{ $t('BUILDING_COMPLEXES.COHABITANTS') }}
              </strong>
            </v-list-item-title>

            <v-list-item-subtitle
              v-for="cohabitant in cohabitants"
              :key="cohabitant.id"
            >
              <router-link
                class="text-decoration-none text-wrap"
                target="_blank"
                :to="{
                  name: 'persons.show',
                  params: { id: cohabitant.person_id }
                }"
              >
                {{ getCohabitantName(cohabitant) }}
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon small v-on="on">mdi-eye-outline</v-icon>
                  </template>
                  <span>{{ $t('ITEM.VIEW') }}</span>
                </v-tooltip>
              </router-link>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { curry, get } from 'lodash';

export default {
  name: 'ApartmentInformation',

  props: {
    apartment: {
      type: Object,
      required: true
    },
    cohabitants: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    provider() {
      return curry(get)(this.apartment);
    },

    customer() {
      return this.provider(
        'building.building_complex.business_customer.name',
        ''
      );
    },

    managementCompany() {
      return this.provider(
        'building.building_complex.management_company.name',
        ''
      );
    },

    concierge() {
      const concierge = this.provider(
        'building.building_complex.concierge.person',
        null
      );

      if (!concierge) {
        return '';
      }

      return `${concierge.first_name} ${concierge.last_name}`.trim();
    }
  },

  methods: {
    getCohabitantName(cohabitant) {
      if (cohabitant.person) {
        cohabitant = cohabitant.person;
      }

      return `${cohabitant.first_name} ${cohabitant.last_name}`.trim();
    }
  }
};
</script>
